import { styled, remCalc } from '../../lib/styles';
export const MonthGrid = styled.div.withConfig({
  displayName: "MonthCalendarStyles__MonthGrid",
  componentId: "h9fvy0-0"
})(["flex:1 1 auto;overflow:auto;width:100%;"]);
export const Header = styled.div.attrs({
  'data-test-id': 'month-calendar-header'
})(({
  theme
}) => `
  background: ${theme.color[theme.uiAddonCalendars.headerBackground]};
  border: 1px solid ${theme.color['border-core-subtle']};
  border-bottom: none;
  color: ${theme.color['text-interactive-default']};
  display: flex;
  height: ${theme.uiAddonCalendars.headerHeight};
  flex-shrink: 0;

  * {
    font-size: ${remCalc(12)};
  }
`);
export const CompactHeader = styled.div.withConfig({
  displayName: "MonthCalendarStyles__CompactHeader",
  componentId: "h9fvy0-1"
})(["color:", ";display:flex;height:", ";flex-shrink:0;*{font-size:", ";}"], ({
  theme
}) => theme.color['border-core-subtle-pressed'], ({
  theme
}) => theme.uiAddonCalendars.headerHeight, remCalc(12));
export const RowWrapper = styled.div.withConfig({
  displayName: "MonthCalendarStyles__RowWrapper",
  componentId: "h9fvy0-2"
})(["position:relative;width:100%;"]);
export const CompactRowWrapper = styled.div.withConfig({
  displayName: "MonthCalendarStyles__CompactRowWrapper",
  componentId: "h9fvy0-3"
})(["padding-top:48px;min-height:48px;position:relative;width:100%;"]);
export const Row = styled.div.attrs(({
  isLastRow
}) => ({
  'data-test-id': 'month-calendar-row',
  'data-test-is-last-row': isLastRow
})).withConfig({
  displayName: "MonthCalendarStyles__Row",
  componentId: "h9fvy0-4"
})(["border-bottom:", ";border-left:1px solid;border-top:1px solid;border-color:", ";"], ({
  isLastRow
}) => isLastRow ? '1px solid' : 'none', ({
  theme
}) => theme.color['border-core-subtle']);
export const CompactRow = styled.div.withConfig({
  displayName: "MonthCalendarStyles__CompactRow",
  componentId: "h9fvy0-5"
})(["bottom:0;left:0;position:absolute;right:0;top:0;"]);
export const EventsWrapper = styled.div.withConfig({
  displayName: "MonthCalendarStyles__EventsWrapper",
  componentId: "h9fvy0-6"
})(["bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%;"]);
const baseEventStyles = eventHeight => `
  margin-left: ${remCalc(4)};
  margin-right: ${remCalc(4)};
  height: ${eventHeight};
`;
function getEventTopMargin({
  index,
  eventHeight,
  eventTopPadding,
  eventMargin
}) {
  if (index > 0) {
    return `calc((${index} * ${eventHeight}) + (${index} * ${eventMargin}) + ${eventTopPadding})`;
  }
  return `calc((${index} * ${eventHeight}) + ${eventTopPadding} )`;
}
const eventWidthWithWhiteSpace = ({
  dayLength = 1,
  dayWidthPercent
}) => `calc(${dayLength * dayWidthPercent}% - ${remCalc(8)} )`;
export const Event = styled.div.withConfig({
  displayName: "MonthCalendarStyles__Event",
  componentId: "h9fvy0-7"
})(({
  dayOfWeek,
  index,
  dayLength,
  theme: {
    uiAddonCalendars: {
      dayWidthPercent,
      eventMargin,
      monthView: {
        eventHeight,
        eventTopPadding
      }
    }
  }
}) => `
  ${baseEventStyles(eventHeight)};
  left:
    ${dayOfWeek * dayWidthPercent}%;
  margin-top: ${getEventTopMargin({
  index,
  eventHeight,
  eventTopPadding,
  eventMargin
})};
  position: absolute;
  width: ${eventWidthWithWhiteSpace({
  dayLength,
  dayWidthPercent
})};
  z-index: 3;
  overflow: hidden;
`);
export const CompactEventIndicator = styled.div.withConfig({
  displayName: "MonthCalendarStyles__CompactEventIndicator",
  componentId: "h9fvy0-8"
})(["left:", ";margin-top:3px;margin-left:-3px;position:absolute;width:6px;height:6px;z-index:3;background-color:", ";border-radius:100px;"], ({
  dayOfWeek,
  theme: {
    uiAddonCalendars: {
      dayWidthPercent
    }
  }
}) => `${dayOfWeek * dayWidthPercent + dayWidthPercent / 2}%`, ({
  theme
}) => theme.color['icon-core-default']);
export const OverflowButton = styled.div.withConfig({
  displayName: "MonthCalendarStyles__OverflowButton",
  componentId: "h9fvy0-9"
})(({
  dayColumnIndex,
  theme: {
    uiAddonCalendars: {
      dayWidthPercent,
      monthView: {
        eventHeight
      }
    }
  }
}) => `
  ${baseEventStyles(eventHeight)};
  align-items: center;
  bottom: ${remCalc(5)};
  display: flex;
  font-size: 0.75rem;
  height: ${eventHeight};
  justify-content: center;
  left: ${dayColumnIndex * dayWidthPercent}%;
  position: absolute;
  width: ${eventWidthWithWhiteSpace({
  dayWidthPercent
})};
  z-index: 3;
`);
export const Week = styled.div.withConfig({
  displayName: "MonthCalendarStyles__Week",
  componentId: "h9fvy0-10"
})(["display:flex;flex-direction:row;height:100%;position:relative;width:100%;"]);
export const CompactDay = styled.div.withConfig({
  displayName: "MonthCalendarStyles__CompactDay",
  componentId: "h9fvy0-11"
})(["background-color:", ";border-radius:100px;color:", ";position:relative;width:40px;height:40px;margin-left:auto;margin-right:auto;margin-top:4px;&:hover{cursor:", ";background-color:", ";color:", ";transition:background-color 0.3s,color 0.3s;}"], ({
  isCurrentDay,
  isToday,
  theme
}) => {
  if (isToday) {
    return theme.color['icon-core-default'];
  } else if (isCurrentDay) {
    return theme.color['border-core-disabled'];
  }
  return null;
}, ({
  isOutsideMonth,
  isToday,
  theme
}) => {
  if (isToday) {
    return theme.color['fill-surface-default'];
  } else if (isOutsideMonth) {
    return theme.color['border-core-default'];
  }
  return theme.color['icon-core-default'];
}, ({
  isCurrentDay
}) => isCurrentDay ? 'default' : 'pointer', ({
  isToday,
  theme
}) => {
  if (isToday) {
    return theme.color['icon-core-default'];
  }
  return theme.color['border-core-disabled'];
}, ({
  isToday,
  theme
}) => {
  if (isToday) {
    return theme.color['fill-surface-default'];
  }
  return theme.color['fill-surface-default'];
});
export const CompactDayWrapper = styled.div.withConfig({
  displayName: "MonthCalendarStyles__CompactDayWrapper",
  componentId: "h9fvy0-12"
})(["flex:1 1 auto;position:relative;"]);
export const CompactDayText = styled.span.withConfig({
  displayName: "MonthCalendarStyles__CompactDayText",
  componentId: "h9fvy0-13"
})(["width:20px;text-align:center;position:absolute;left:0;right:0;margin-left:auto;margin-right:auto;margin-top:9px;"]);